module.exports = "<app-social-media-sharing [Text]=\"text\" [ItemUrl]=\"itemUrl\"></app-social-media-sharing>\r\n"